module.exports = __webpack_public_path__ + "img/MARCONFORT_icon.ico";